import { init } from "shareon";
import Prism from "prismjs";
import Fuse from "fuse.js";

window.$ = document.querySelector.bind(document);
window.$$ = document.querySelectorAll.bind(document);

const HTMLdoc = document.documentElement;
const lightSwitch = $("#lightSwitch");
const lightSwitchIcon = lightSwitch.querySelector("#lightSwitchIcon");
const searchForm = $("#searchForm");
const searchFormBtn = $("#searchBtn");
const searchResults = $("#searchResults");
const searchValue = $("#searchValue");
const searchCategoryValue = $("#searchCategoryValue");
const categories = $("#categories");
const acceptCookieBtn = $("#acceptCookies");
const cookieWall = $(".cookie-wall");
const linkForm = $("#addLinkForm");

const linkSearchCache = {};

init();
// INIT
const storedTheme = localStorage.getItem("colorMode");
if (storedTheme) {
	HTMLdoc.setAttribute("data-theme", storedTheme);
	lightSwitchIcon.innerHTML =
		storedTheme === "dark" ? "dark_mode" : "light_mode";
}

// SET COLOR HTML ATTR
if (!localStorage.getItem("colorMode")) {
	const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
	HTMLdoc.setAttribute("data-theme", prefersDark ? "dark" : "light");
	lightSwitchIcon.innerHTML =
		prefersDark === "dark" ? "dark_mode" : "light_mode";
}

// FUNCTIONS
lightSwitch.addEventListener("click", () => {
	let newTheme = "";
	if (HTMLdoc.getAttribute("data-theme") === "dark") {
		newTheme = "light";
	} else {
		newTheme = "dark";
	}

	HTMLdoc.setAttribute("data-theme", newTheme);
	localStorage.setItem("colorMode", newTheme);
	lightSwitchIcon.innerHTML = newTheme === "dark" ? "dark_mode" : "light_mode";
});

// Poll for gtag
function waitForGtag (callback) {
	const interval = setInterval(() => {
		if (typeof window.gtag === "function") {
			clearInterval(interval); // Stop polling
			callback(); // Execute your callback function
		}
	}, 200); // Check every 200ms
}

// Approve
function approveGoogle () {
	waitForGtag(() => {
		window.gtag("consent", "update", {
			ad_user_data: "granted",
			ad_personalization: "granted",
			ad_storage: "granted",
			analytics_storage: "granted",
		});
	});
}

// Google default
waitForGtag(() => {
	window.gtag("consent", "default", {
		ad_storage: "denied",
		ad_user_data: "denied",
		ad_personalization: "denied",
		analytics_storage: "denied",
	});
});

if (acceptCookieBtn) {
	acceptCookieBtn.addEventListener("click", () => {
		cookieWall.classList.add("hidden");
		localStorage.setItem("cookiesAccepted", true);
		approveGoogle();
	});
}

// if cookies are accepted, remove
if (!localStorage.getItem("cookiesAccepted")) {
	cookieWall.classList.remove("hidden");
	approveGoogle();
}

window.addEventListener("scroll", () => {
	const header = document.querySelector("header");
	if (window.scrollY > 0) {
		header.classList.add("scroll");
	} else {
		header.classList.remove("scroll");
	}
});

const searchResultTpl = (url, title, description, category) => {
	return `<article class="card">
			<div class="card-header">
				<a href="${url}" target="_blank">${title}</a>
				<span class="material-symbols-outlined">
					terminal
				</span>
			</div>
			<p>${description}</p>
			<footer>
				Categorie: ${category} 
			</footer>
		  </article>`;
};

const noResults = () => {
	return `<article class="card">
			<h1>Geen resultaten gevonden</h1>
			<p>Pas de zoekcriteria aan!</p>
		  </article>`;
};

const nextPageBtnTpl = () => {
	return `<hr><div class="next-page""><button class="secondary" id="nextPage">Meer resultaten <span class="material-symbols-outlined">arrow_drop_down</span></button></div>`;
};

const linkSearch = async (currentPage = 1) => {
	// cache per country, AJAX fetch
	const category = $("#searchCategoryValue").value;
	const resultsPerPage = 5;

	if (!linkSearchCache[category]) {
		searchFormBtn.setAttribute("aria-busy", "true");

		const response = await fetch(
			`${searchForm.dataset.url}?category=${$("#searchCategoryValue").value}`,
		); // config path
		linkSearchCache[category] = await response.json();
	}
	searchFormBtn.removeAttribute("aria-busy");

	const fuseOptions = {
		// isCaseSensitive: false,
		// includeScore: false,
		// ignoreDiacritics: false,
		// shouldSort: true,
		// includeMatches: false,
		// findAllMatches: false,
		// minMatchCharLength: 1,
		// location: 0,
		// threshold: 0.6,
		// distance: 100,
		// useExtendedSearch: false,
		// ignoreLocation: false,
		// ignoreFieldNorm: false,
		// fieldNormWeight: 1,
		keys: ["title", "description", "url", "category"],
	};
	/**
	 * "title": "Gezonde Recepten",
		"description": "Beste recepten dagelijks",
		"url": "https://voorbeeld.com/gezonderecepten",
		"category": "Gezo
	 */

	const fuse = new Fuse(linkSearchCache[category], fuseOptions);

	// Change the pattern
	const searchPattern = $("#searchValue").value.trim();
	const searchResult = searchPattern ? fuse.search(searchPattern) : linkSearchCache[category].map((item) => ({ item }));

	//const nextPage = () => page++;

	if (searchResult.length) {
		categories.classList.add("hidden");

		const searchResultsHTML = searchResult
			.map((result, index) => {
				console.log({ index });
				if (index + 1 < currentPage * resultsPerPage) {
					return searchResultTpl(
						result.item.url,
						result.item.title,
						result.item.description,
						result.item.category,
					);
				}
			})
			.join("");

		searchResults.innerHTML = searchResultsHTML;

		if (currentPage * resultsPerPage < searchResult.length) {
			searchResults.innerHTML = searchResults.innerHTML + nextPageBtnTpl();
			$("#nextPage").addEventListener("click", () => {
				console.log("clicky");
				console.log({ currentPage });
				return linkSearch(currentPage + 1);
			});
		}
	} else {
		searchResults.innerHTML = noResults();
	}
};

// SEARCH FORM
if (searchForm) {
	searchForm.addEventListener("submit", async (e) => {
		e.preventDefault(); // Stops the form submission
		linkSearch();
	});

	resetBtn.addEventListener("click", (e) => {
		e.preventDefault();
		searchResults.innerHTML = "";
		categories.classList.remove("hidden");
		searchCategoryValue.value = "all";
		searchValue.value = "";
	});
}

// copy button
document.addEventListener("DOMContentLoaded", () => {
	const codeBlocks = document.querySelectorAll("pre > code");

	for (const codeBlock of codeBlocks) {
		const pre = codeBlock.parentElement;

		// Create wrapper
		const wrapper = document.createElement("div");
		wrapper.className = "code-wrapper";
		pre.parentNode.insertBefore(wrapper, pre);
		wrapper.appendChild(pre);

		// Create icon button
		const button = document.createElement("button");
		button.className = "copy-btn";
		button.innerHTML = `<span class="material-symbols-outlined">content_copy</span>`;
		wrapper.appendChild(button);

		// Copy logic
		button.addEventListener("click", () => {
			navigator.clipboard.writeText(codeBlock.textContent).then(() => {
				button.innerHTML = `<span class="material-symbols-outlined">check</span>`;
				setTimeout(() => {
					button.innerHTML = `<span class="material-symbols-outlined">content_copy</span>`;
				}, 2000);
			});
		});
	}
});

// formatters
const trimValue = (input) => {
	input.value = input.value.trim();
};

// validators
const minWords = (inputValue, nrOfWords) => {
	return inputValue.split(" ").length >= nrOfWords;
};
const minLength = (inputValue, minLength) => {
	return inputValue.length >= minLength;
};
const startWithLetter = (inputValue) => {
	return /^[a-zA-Z]/.test(inputValue);
};

const isValidUrl = (validUrl) => {
  try {
    const url = new URL(validUrl);

    // Alleen http of https
    if (!["http:", "https:"].includes(url.protocol)) return false;

    // Hostname moet minimaal één punt bevatten (bijv. nu.nl)
    if (!url.hostname.includes(".")) return false;

    // Hostname mag niet beginnen of eindigen met een punt
    if (url.hostname.startsWith(".") || url.hostname.endsWith(".")) return false;

    // Geen localhost of IP-adressen
    if (
      url.hostname === "localhost" ||
      /^[\d.]+$/.test(url.hostname) // IP-adres
    ) return false;

    return true;
  } catch (_) {
    return false;
  }
};

const loadJson = async (url) => {
  try {
    const response = await fetch(url);
    console.log('Status:', response.status, response.statusText);

    const text = await response.text();
    console.log('Raw response:', text);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const value = JSON.parse(text);
    console.log({ value });
    return value;
  } catch (error) {
    console.error('loadJson error:', error);
    return null;
  }
};

// FORM
if (linkForm) {
	const submitBtn = $("#submitBtn");
	const validatorUrl = linkForm.dataset.validationUrl;
	const suggestionsUrl = linkForm.dataset.suggestionsUrl;
	const serverMsg = $("#serverMsg");
	const backLinkInstruction = $("#backLinkInstruction");

	submitBtn.setAttribute("disabled", true);

	loadJson(suggestionsUrl).then((data) => {
		console.log({data})
		const suggestionsData = data;
		linkForm.setAttribute("novalidate", "");

		linkForm.addEventListener("submit", async (e) => {
			e.preventDefault();

			try {
				const validationReq = await fetch(
					`${validatorUrl}?backurl=${linkForm.link_backurl.value}`,
				);

				if (!validationReq.ok) {
					throw new Error(`Server error: ${validationReq.status}`);
				}

				const result = await validationReq.json();

				if (result.valid === true) {
					serverMsg.innerHTML = "";
					linkForm.submit(); // Proceed
				} else {
					serverMsg.innerHTML = result.message;
				}
			} catch (error) {
				console.error("Validation request failed:", error);
			}
		});

		const linkTitleValidator = (e) => {
			trimValue(e.target);
			const value = e.target.value;
			const helper = e.target.ariaDescribedByElements[0];

			e.target.setAttribute("aria-invalid", false);
			helper.innerHTML = "";

			if (!startWithLetter(value)) {
				helper.innerHTML = "Titel moet starten met een letter!";
				e.target.setAttribute("aria-invalid", true);
			}

			if (!minLength(value, 6) || !minWords(value, 3)) {
				helper.innerHTML = "Titel moet minimaal 3 woorden bevatten.";
				e.target.setAttribute("aria-invalid", true);
			}

			enableSubmit();
		};

		const linkDescriptionValidator = (e) => {
			trimValue(e.target);
			const value = e.target.value;
			const helper = e.target.ariaDescribedByElements[0];

			e.target.setAttribute("aria-invalid", false);
			helper.innerHTML = "";

			if (!minLength(value, 10) || !minWords(value, 5)) {
				helper.innerHTML = "Beschrijving moet minimaal 5 woorden bevatten.";
				e.target.setAttribute("aria-invalid", true);
			}

			enableSubmit();
		};

		const linkCategoryValidator = (e) => {
			const value = e.target.value;
			const helper = e.target.ariaDescribedByElements[0];

			e.target.setAttribute("aria-invalid", false);
			helper.innerHTML = "";

			if (value === "") {
				e.target.setAttribute("aria-invalid", true);
				helper.innerHTML = "Kies een categorie.";
			}

			enableSubmit();
		};

		const linkBackurlValidator = (e) => {
			trimValue(e.target);
			const value = e.target.value;
			const helper = e.target.ariaDescribedByElements[0];

			e.target.setAttribute("aria-invalid", false);
			helper.innerHTML = "";

			if (!isValidUrl(value)) {
				e.target.setAttribute("aria-invalid", true);
				helper.innerHTML =
					"Vul hier een volledig geldige url in, bijvoorbeeld: http://test.nl";
			}

			enableSubmit();
		};

		const createNewBackLink = (e) => {
			const value = e.target.value;
			const categoryValue = suggestionsData[value].suggestions;
			const randomIndex = Math.floor(Math.random() * categoryValue.length);
			const backLinkCode = $('#backLinkCode');
			// value must be url
			const backLinkHTML = `&lt;a href="${suggestionsData[value].url}">\n${categoryValue[randomIndex]}\n&lt;/a>`;
			linkForm.backlink_code.value = backLinkHTML.replace(/[\r\n]+/g, '').trim();
			backLinkCode.innerHTML = backLinkHTML;

			backLinkInstruction.classList.remove('hidden');

			Prism.highlightElement(backLinkCode);
		};

		const enableSubmit = () => {
			submitBtn.setAttribute("disabled", true);

			if (linkForm.terms.checked) {
				const allValid = [
					...linkForm.querySelectorAll("input, select, textarea"),
				].every((el) => {
					el.blur();
					return el.getAttribute("aria-invalid") !== "true";
				});

				if (allValid) {
					submitBtn.removeAttribute("disabled");
				}
			}
		};

		// BLUR validation
		linkForm.link_title.addEventListener("blur", linkTitleValidator);
		linkForm.link_description.addEventListener("blur", linkDescriptionValidator);
		linkForm.link_category.addEventListener("blur", linkCategoryValidator);
		linkForm.link_backurl.addEventListener("blur", linkBackurlValidator);

		// ENABLE SUBMIT with blur triggering
		linkForm.terms.addEventListener("click", () => {
			// Trigger blur on all fields
			const fieldIds = ["link_title", "link_description", "link_category", "link_backurl"];

			for (const id of fieldIds) {
				const el = linkForm[id];
				if (el) {
					el.dispatchEvent(new Event("blur", { bubbles: true }));
				}
			}

			enableSubmit();
		});

		// CATEGORY CHANGE
		linkForm.link_category.addEventListener("change", createNewBackLink);
	});
}
